import * as React from 'react';
import { ReactElement } from 'react';
import { twMerge } from 'tailwind-merge';
import { FIELD } from '../__partials/field-classes';
import FormItem from '../__partials/form-item';
import HelpText from '../__partials/help-text';
import Label from '../__partials/label';
import useFieldId from '../__partials/use-field-id';

type IProps = {
  label?: string;
  status?: 'default' | 'error' | 'success';
  statusText?: string;
  helpText?: any;
  isDisabled?: boolean;
  isRequired?: boolean;
  className?: string;
} & React.TextareaHTMLAttributes<HTMLTextAreaElement>;

const TEXTAREA = twMerge(FIELD, 'py-2');

const Textarea = ({
  label,
  status = 'default',
  statusText,
  helpText,
  isDisabled,
  isRequired,
  className,
  id,
  name,
  rows = 4,
  ...props
}: IProps): ReactElement => {
  const textareaId = useFieldId(id, name);

  return (
    <FormItem status={status} isDisabled={isDisabled}>
      {label && <Label label={label} statusText={statusText} id={textareaId} />}
      <div className="flex">
        <textarea
          {...props}
          id={textareaId}
          name={name}
          rows={rows}
          className={twMerge(TEXTAREA, className)}
          disabled={isDisabled}
          required={isRequired}
        />
      </div>
      {helpText && <HelpText text={helpText} status={status} />}
    </FormItem>
  );
};

export default Textarea;
